export function joinNameParts(firstPart, secondPart) {
  return [firstPart, secondPart]
    .map((namePart) => (typeof namePart === 'string' ? namePart.trim() : ''))
    .filter((namePart) => namePart.length > 0)
    .join(' ');
}
